module.exports = __webpack_public_path__ + "img/wait_review_horn.ca8daeae.svg";